import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgNorwayFlag = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 60,
	height: 60,
	viewBox: "0 0 60 60",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M59.7208 26C59.5888 24.9912 59.4049 23.9899 59.1701 23H0.831001C0.596902 23.9901 0.413164 24.9914 0.280495 26H59.7208Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M0.280495 34C0.413091 35.0087 0.59683 36.01 0.831001 37H59.1701C59.4045 36.01 59.5883 35.0087 59.7208 34H0.280495Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M17.9995 2.48828C16.972 2.93622 15.9706 3.44165 15 4.00217V55.9982C15.9702 56.5589 16.9717 57.0637 17.9995 57.5102V2.48828Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M26.0003 0.262145V59.7369C26.995 59.8752 27.9961 59.9634 28.9998 60.001V0.000488281C27.9842 0.0332299 26.9858 0.13144 26.0003 0.262145Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M0 29.9998C0.00262109 31.3378 0.0938317 32.6741 0.273033 34.0001H59.7256C60.091 31.3459 60.0915 28.6543 59.727 26H0.274419C0.0940072 27.3257 0.00233031 28.6619 0 29.9998H0Z",
			fill: "#2A5F9E"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M17.9997 57.4959C20.5494 58.6092 23.2424 59.36 26.0004 59.7263V0.273438C23.2425 0.640259 20.5496 1.39097 17.9997 2.50377V57.4959Z",
			fill: "#2A5F9E"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M15.0001 23.0003V4.02344C11.4755 6.06116 8.40193 8.79417 5.96617 12.0564C3.53042 15.3186 1.7833 19.042 0.830956 23.0003H15.0001Z",
			fill: "#ED4C5C"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M15.0001 37.0234V56C11.4755 53.9624 8.4019 51.2295 5.96614 47.9673C3.53038 44.7051 1.78327 40.9817 0.830956 37.0234H15.0001Z",
			fill: "#ED4C5C"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M30.0005 0.000488281C29.6644 0.000488281 29.334 0.0143631 28.9999 0.0254674V23.0001H59.1703C57.5971 16.4478 53.8641 10.6157 48.5726 6.44346C43.281 2.2712 36.739 0.00167746 30.0005 0.000488281V0.000488281Z",
			fill: "#ED4C5C"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M28.9999 37.0005V59.9752C29.334 59.9843 29.6644 60.0002 30.0005 60.0002C36.7389 59.9985 43.2807 57.7289 48.5722 53.5567C53.8636 49.3845 57.5968 43.5527 59.1703 37.0005H28.9999Z",
			fill: "#ED4C5C"
		})
	]
});
export default SvgNorwayFlag;
